module.exports = __webpack_public_path__ + "static/media/8.5ee87859.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/8.jpg
// module id = 541
// module chunks = 0